import type { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { ArchiveBoxIcon } from '@heroicons/react/24/outline'
import { DefaultModal } from '@/shared/components/DefaultModal'
import { Button } from '@/interaxDesignSystemComponents'
import { INTERAX_COLORS } from '@/constants/colors'
import { useTranslation } from '@/shared/hooks/useIntractionTranslate'

export interface ArchiveReflectionModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isArchiving?: boolean
  body?: string
}

export const ArchiveReflectionModal: FC<ArchiveReflectionModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isArchiving = false,
  body
}) => {
  const { t } = useTranslation()

  return (
    <DefaultModal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="460px"
      backgroundColor={INTERAX_COLORS.heritageBlue}
      showCloseButton={!isArchiving}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <ArchiveBoxIcon
            aria-hidden="true"
            style={{ width: 24, height: 24, color: INTERAX_COLORS.thunderGrey, flexShrink: 0 }}
          />
          <Typography variant="h5" sx={{ color: INTERAX_COLORS.white, fontWeight: 600 }}>
            {t('facilitator.reflection.archive.confirmTitle')}
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ color: INTERAX_COLORS.thunderGrey }}>
          {body ?? t('facilitator.reflection.archive.confirmBody')}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <Button variant="secondary" onClick={onClose} disabled={isArchiving}>
            {t('facilitator.reflection.send.cancelButton')}
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={isArchiving}>
            {t('facilitator.reflection.actions.archive')}
          </Button>
        </Box>
      </Box>
    </DefaultModal>
  )
}
